export const TARGET_TRANSLATION_LANGUAGES = [
  { isoCode: 'fr', img: '/Images/img_flag/FR_flag.png', language: 'Français' },
  { isoCode: 'en', img: '/Images/img_flag/GB_flag.png', language: 'Anglais' },
  { isoCode: 'es', img: '/Images/img_flag/ES_flag.png', language: 'Espagnol' },
  { isoCode: 'de', img: '/Images/img_flag/DE_flag.png', language: 'Allemand' },
  { isoCode: 'it', img: '/Images/img_flag/IT_flag.png', language: 'Italien' },
  { isoCode: 'pt', img: '/Images/img_flag/PT_flag.png', language: 'Portugais' },
  { isoCode: 'nl', img: '/Images/img_flag/NL_flag.png', language: 'Néerlandais' },
  { isoCode: 'ar', img: null, language: 'Arabe', flagEmoji: '🇸🇦' },
];

const normalizeText = (value) =>
  String(value ?? '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

const TARGET_LANGUAGE_ALIASES = {
  fr: ['fr', 'francais', 'french'],
  en: ['en', 'anglais', 'english'],
  de: ['de', 'allemand', 'german', 'deutsch'],
  es: ['es', 'espagnol', 'spanish', 'espanol'],
  it: ['it', 'italien', 'italian', 'italiano'],
  nl: ['nl', 'neerlandais', 'hollandais', 'flamand', 'dutch', 'nederlands'],
  pt: ['pt', 'portugais', 'portuguese', 'portugues'],
  ar: ['ar', 'arabe', 'arabic', 'arabe standard moderne'],
};

const getAgentLanguageCandidates = (agent) => {
  const raw =
    agent?.language ??
    agent?.langue ??
    agent?.lang ??
    agent?.code ??
    '';

  if (raw && typeof raw === 'object') {
    return [raw.language, raw.name, raw.code, raw.langue, raw.id]
      .filter((value) => value != null && String(value).trim())
      .map((value) => normalizeText(value));
  }

  return [normalizeText(raw)].filter(Boolean);
};

const getTargetLanguageAliases = (targetLanguage) => {
  const isoCode = String(targetLanguage?.isoCode || '').toLowerCase();
  const aliases = new Set([
    ...(TARGET_LANGUAGE_ALIASES[isoCode] || []),
    normalizeText(targetLanguage?.language),
    isoCode,
  ]);
  return Array.from(aliases).filter(Boolean);
};

const matchesLanguageAlias = (agentValue, aliases) =>
  aliases.some(
    (alias) =>
      agentValue === alias ||
      agentValue.includes(alias) ||
      alias.includes(agentValue)
  );

export const filterAgentsByTargetLanguage = (agents, targetLanguage) => {
  if (!targetLanguage) return [];
  const aliases = getTargetLanguageAliases(targetLanguage);

  return (agents || []).filter((agent) => {
    const candidates = getAgentLanguageCandidates(agent);
    return candidates.some((candidate) => matchesLanguageAlias(candidate, aliases));
  });
};

export const getAgentLanguageLabel = (agent) => {
  const raw =
    agent?.language ??
    agent?.langue ??
    agent?.lang ??
    agent?.code ??
    '';

  return resolveLanguageDisplayLabel(raw);
};

export const resolveLanguageDisplayLabel = (value) => {
  if (value == null) return '';
  if (typeof value === 'string' || typeof value === 'number') {
    return String(value).trim();
  }
  if (typeof value === 'object') {
    const candidate =
      value.language ?? value.name ?? value.code ?? value.langue ?? value.id ?? '';
    if (candidate && typeof candidate === 'object') {
      return resolveLanguageDisplayLabel(candidate);
    }
    return String(candidate || '').trim();
  }
  return '';
};
